import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CynoFormModule } from '@app/shared/cyno-form/cyno-form.module';
import { PrettyLicensePlateModule } from '@app/shared/directives/pretty-license-plate.module';
import { OutSalesModule } from 'outshared-lib';
import { FunnelEntryContainerComponent } from './funnel-entry-container.component';
import { FunnelEntryComponent } from './funnel-entry.component';
import { VoertuigenFormLargeComponent } from './voertuigen-form-large.component';
import { WoonverzekeringFormLargeComponent } from './woonverzekering-form-large.component';
import { WoonverzekeringFormSmallComponent } from './woonverzekering-form-small.component';

@NgModule({
    imports: [
        CommonModule,
        CynoFormModule,
        PrettyLicensePlateModule,
        OutSalesModule,
    ],
    exports: [
        FunnelEntryComponent,
        FunnelEntryContainerComponent,
        VoertuigenFormLargeComponent,
        WoonverzekeringFormSmallComponent,
        WoonverzekeringFormLargeComponent,
    ],
    declarations: [
        FunnelEntryComponent,
        FunnelEntryContainerComponent,
        VoertuigenFormLargeComponent,
        WoonverzekeringFormSmallComponent,
        WoonverzekeringFormLargeComponent,
    ],
    providers: [],
})
export class FunnelEntryModule {}
